import React, { forwardRef } from 'react';
import classNames from 'classnames';
import omitBy from 'lodash/omitBy';
import { withSpacingStyles } from '../withSpacingStyles';

import styles from './styles.module.scss';

type Props = {
  className?: ?string,
  children?: React.Node,
  tag: string,
  noPadding: boolean,
  id?: string,
  xs?: number,
  sm?: number,
  md?: number,
  lg?: number,
  xl?: number,
  xxl?: number,
  xxxl?: number,
  xsOffset?: number,
  smOffset?: number,
  mdOffset?: number,
  lgOffset?: number,
  xlOffset?: number,
  xxlOffset?: number,
  xxxlOffset?: number,
};

const sizes = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'xxxl', 'lgk'];

const _Col = forwardRef(({ id, children, className, noPadding, tag, ...rest }: Props, ref) => {
  const TagName = tag;

  const gridProps = sizes.reduce((res, size) => res.concat([size, `${size}Offset`]), []);

  const gridClassNames = gridProps.reduce(
    (res, size) => ({
      [styles[`col-${size}-${rest[size]}`]]: !!rest[size],
      ...res,
    }),
    {}
  );

  return (
    <TagName
      id={id}
      ref={ref}
      className={classNames(className, gridClassNames, { [styles.noPadding]: noPadding })}
      {...omitBy(rest, (value, key) => gridProps.includes(key))}
    >
      {children}
    </TagName>
  );
});

export const Col = withSpacingStyles(_Col);

Col.defaultProps = {
  tag: 'div',
  noPadding: false,
};
